'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Arrow = function (_React$Component) {
	(0, _inherits3.default)(Arrow, _React$Component);

	function Arrow() {
		(0, _classCallCheck3.default)(this, Arrow);
		return (0, _possibleConstructorReturn3.default)(this, (Arrow.__proto__ || Object.getPrototypeOf(Arrow)).apply(this, arguments));
	}

	(0, _createClass3.default)(Arrow, [{
		key: 'render',
		value: function render() {
			var width = this.props.width;

			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ className: 'BurgerArrow' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '698417688',
					css: '.BurgerArrow.BurgerActive .BurgerInner:before{-webkit-transform:translate3d(' + width * -0.2 + 'px,0,0) rotate(-45deg) scale(0.7,1);-ms-transform:translate3d(' + width * -0.2 + 'px,0,0) rotate(-45deg) scale(0.7,1);transform:translate3d(' + width * -0.2 + 'px,0,0) rotate(-45deg) scale(0.7,1);}.BurgerArrow.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(' + width * -0.2 + 'px,0,0) rotate(45deg) scale(0.7,1);-ms-transform:translate3d(' + width * -0.2 + 'px,0,0) rotate(45deg) scale(0.7,1);transform:translate3d(' + width * -0.2 + 'px,0,0) rotate(45deg) scale(0.7,1);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9hcnJvdy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVdUIsQUFHbUcsQUFHRCwyUUFDekYsR0FIQSIsImZpbGUiOiIuLi8uLi9zcmMvdHlwZXMvYXJyb3cuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5cbmltcG9ydCBCYXNlIGZyb20gJy4uL2Jhc2UnXG5pbXBvcnQgZGVmYXVsdFByb3BzIGZyb20gJy4uL2RlZmF1bHQtcHJvcHMnXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEFycm93IGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50e1xuXHRyZW5kZXIoKXtcblx0XHRsZXQgeyB3aWR0aCB9ID0gdGhpcy5wcm9wc1xuXHRcdHJldHVybiAoXG5cdFx0XHQ8QmFzZSBjbGFzc05hbWU9J0J1cmdlckFycm93JyB7Li4udGhpcy5wcm9wc30+XG5cdFx0XHRcdDxzdHlsZSBqc3ggZ2xvYmFsPntgXG5cdFx0XHRcdFx0LkJ1cmdlckFycm93e1xuXHRcdFx0XHRcdFx0Ji5CdXJnZXJBY3RpdmV7XG5cdFx0XHRcdFx0XHRcdC5CdXJnZXJJbm5lcntcblx0XHRcdFx0XHRcdFx0XHQmOmJlZm9yZXtcblx0XHRcdFx0XHRcdFx0XHRcdHRyYW5zZm9ybTogdHJhbnNsYXRlM2QoJHt3aWR0aCAqIC0wLjJ9cHgsIDAsIDApIHJvdGF0ZSgtNDVkZWcpIHNjYWxlKDAuNywgMSk7XG5cdFx0XHRcdFx0XHRcdFx0fVxuXHRcdFx0XHRcdFx0XHRcdCY6YWZ0ZXJ7XG5cdFx0XHRcdFx0XHRcdFx0XHR0cmFuc2Zvcm06IHRyYW5zbGF0ZTNkKCR7d2lkdGggKiAtMC4yfXB4LCAwLCAwKSByb3RhdGUoNDVkZWcpIHNjYWxlKDAuNywgMSk7XG5cdFx0XHRcdFx0XHRcdFx0fVxuXHRcdFx0XHRcdFx0XHR9XG5cdFx0XHRcdFx0XHR9XG5cdFx0XHRcdFx0fVxuXHRcdFx0XHRgfTwvc3R5bGU+XG5cdFx0XHQ8L0Jhc2U+XG5cdFx0KVxuXHR9XG59XG5cbkFycm93LmRlZmF1bHRQcm9wcyA9IGRlZmF1bHRQcm9wcyJdfQ== */\n/*@ sourceURL=../../src/types/arrow.js */',
					dynamic: [width * -0.2, width * -0.2]
				})
			);
		}
	}]);
	return Arrow;
}(_react2.default.Component);

exports.default = Arrow;


Arrow.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=arrow.js.map